import { useQuery, gql } from "utils/urql";
import { RelatedVideosQuery, RelatedVideosQueryVariables } from "types/api";
import styles from "./ArticleRelatedVideos.module.scss";

const RELATED_VIDEOS_QUERY = gql`
  query relatedVideos($id: ID!, $preview: String) {
    relatedVideos(id: $id, preview: $preview) {
      river(first: 1) {
        edges {
          node {
            ... on VideoArticle {
              embedUrl
              title
            }
          }
        }
      }
    }
  }
`;

const ArticleRelatedVideos = ({
  id,
  preview,
}: {
  id: string;
  preview?: string | null;
}) => {
  const [{ data }] = useQuery<RelatedVideosQuery, RelatedVideosQueryVariables>({
    query: RELATED_VIDEOS_QUERY,
    variables: {
      id,
      preview,
    },
  });

  const relatedVideos = data?.relatedVideos;
  const videos = relatedVideos?.river.edges;
  if (!videos?.length) return null;

  return (
    <>
      {videos?.map((video) => {
        if (video.node.__typename === "VideoArticle") {
          return (
            <section className={styles.root}>
              <h2 className={styles.header}>Related Videos</h2>
              <div className={styles.wrapper}>
                <iframe
                  title={video.node.title}
                  src={video.node.embedUrl}
                  frameBorder="0"
                  allowFullScreen
                  className={styles.video}
                />
              </div>
            </section>
          );
        }
      })}
    </>
  );
};

export default ArticleRelatedVideos;
